<template>
  <div class="c-form--default">
    <div class="c-form-content">
      <div
        v-if="imageUrl"
        class="c-card-media u-mb--l"
      >
        <img
          :src="imageUrl"
          :alt="translations.title"
          width="330"
          height="206"
          class="c-card-image"
        >
      </div>
      <div
        class="css-loader-parent"
        :class="{ 'is-loading': loading }"
      >
        <h3
          v-if="translations.title"
          class="h1--md"
        >
          {{ translations.title }}
        </h3>
        <p
          v-if="translations.description"
          class="u-font-size-dates"
        >
          {{ translations.description }}
        </p>

        <div class="c-form-row">
          <table class="c-form-table">
            <tbody>
              <tr
                v-for="(file, index) in files"
                :key="index"
              >
                <td
                  :colspan="index === 0 ? 2 : 1"
                >
                  <div class="c-radio">
                    <label class="c-radio__label">
                      <input
                        :id="file.url"
                        v-model="chosenFile"
                        type="radio"
                        :checked="chosenFile.url === file.url"
                        :value="file"
                        :disabled="!file.url || loading"
                      >
                      <span class="c-radio__checkmark" />
                      <span class="c-radio__text">{{ file.type }}</span>
                    </label>
                  </div>
                </td>
                <td v-if="index === 0">
                  {{ file.size }}
                </td>
              </tr>
              <tr>
                <td
                  class="padding-top"
                  colspan="2"
                >
                  <button
                    class="c-button"
                    :disabled="!chosenFile || loading"
                    @click.prevent.stop="handleDownload"
                  >
                    {{ translations.buttonText }}
                    <IconDownload class="c-base-icon" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <CssLoader
          v-if="loading"
          class="css-loader"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import CssLoader from '@/Redesign/Components/CssLoader.vue'
import useDownloadMedia from '@/Redesign/Compositions/useDownloadMedia'
import { downloadFile } from '@/Redesign/Helpers/files'
import IconDownload from '@/Redesign/Assets/Icons/download.svg'

export default {
  components: {
    CssLoader,
    IconDownload
  },
  setup() {
    const { state } = useDownloadMedia()
    const { imageUrl, translations, files } = state
    const chosenFile = ref(state.files[0])
    const loading = ref(false)

    const handleDownload = async () => {
      if (loading.value) return
      loading.value = true

      const {
        url,
        extension,
        name
      } = chosenFile.value
      await downloadFile({ url, extension, name })
      loading.value = false
    }

    return {
      imageUrl,
      translations,
      files,
      chosenFile,
      loading,

      handleDownload
    }
  }
}
</script>
